import { useTranslations } from "@/contexts/Translation";
import { InfoMessage } from "@/components/InfoMessage/InfoMessage";
import { useUserManagement } from "./UserManagementContext";
import Button from "@/components/Button/Button";
import List from "@/components/List/List";
import Collapsable from "@/components/Collapsable/Collapsable";
import Card from "@/components/Card/Card";
import styles from "./DepartmentsSection.module.css";

type ComponentProps = {
  setShowDepartments: (show: boolean) => void;
};

const DepartmentsSection = ({ setShowDepartments }: ComponentProps) => {
  const t = useTranslations("userManagementForm");
  const { departments } = useUserManagement();

  return (
    <Card className={styles.card} padding='none' variant='collapsable'>
      <Collapsable toggleItem={t("departmentsTitle")} closed={false}>
        <InfoMessage>{t("departmentsInfo")}</InfoMessage>
        {departments.length === 0 && <InfoMessage>{t("noDepartments")}</InfoMessage>}
        {departments.length > 0 && (
          <List
            items={departments.map((d) => (
              <div key={d.id || d.name}>{d.name}</div>
            ))}
          />
        )}
        <Button onClick={() => setShowDepartments(true)}>
          {t(departments.length === 0 ? "addDepartment" : "editDepartment")}
        </Button>
      </Collapsable>
    </Card>
  );
};

export default DepartmentsSection;
